import { __module as captialize } from '../../../../../_virtual/captialize.js';

var hasRequiredCaptialize;

function requireCaptialize () {
	if (hasRequiredCaptialize) return captialize.exports;
	hasRequiredCaptialize = 1;
	(function (module, exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = captialize;
		/**
		 * Captialize a string
		 * @ignore
		 * @param {string} string
		 * @return {string}
		 */
		function captialize(string) {
		  return string.charAt(0).toUpperCase() + string.slice(1);
		}
		module.exports = exports["default"];
		
	} (captialize, captialize.exports));
	return captialize.exports;
}

export { requireCaptialize as __require };
